module.exports = __webpack_public_path__ + "static/media/calendar-checked.5df14eb4.svg";